(function () {
	/* 22.08.2026: Handler delegiert an document, weil facets.js den
	   Container .active-facets-mobile per innerHTML ersetzt - elementgebundene
	   Handler waren nach der ersten AJAX-Filterung weg. Einmalige Bindung,
	   auch bei mehrfachem section:load. */
	if (window.__bs24FacetsMenuGebunden) return;
	window.__bs24FacetsMenuGebunden = true;

	$(document).on('click', 'html.js .no_submit', function (e) {
		e.preventDefault();
	});
	$(document).on('click', '.open_filters,.facets-menu__close,.facets__submit,.facets__reset,.form-menu__mask', function () {
		$('#open_filters_menu').toggleClass('show_menu');
		$('body').toggleClass('overflow-hidden');
	});
})();
